import type {
    Invoice,
    Schedule
} from '@dutchinvoice/types'

// Type for invoices with sync status
export interface SyncedInvoice extends Invoice {
    id: string;
    synced: boolean;
    scheduleId?: string; // Reference to the associated schedule
    scheduleData?: Omit<Schedule, 'id'>; // Temporary schedule data for concept invoices
}

// Money type for calculations
export type UniversalMoney = string

// Loading state enum for better state management
export enum LoadingState {
    IDLE = 'idle',
    LOADING_LOCAL = 'loading_local',
    LOADING_CLOUD = 'loading_cloud',
    SYNCING = 'syncing',
    ERROR = 'error'
}

// Error types for better error handling
export interface StoreError {
    code: string
    message: string
    details?: unknown
}

// Options for invoice merge operation
export interface InvoiceMergeOptions {
    debug?: boolean;
} 